import { Component, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/forms/src/facade/async';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { CompaniesService } from '../../../companies/companies.service';
import { OnDemandDriverModel } from '../../on-demand-drivers.model';
import { Subscription } from 'rxjs/Subscription';
import { take } from 'rxjs/operators';
import { ICompany } from 'app/core/interfaces/company.interface';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';

@Component({
  selector: 'app-on-demand-drivers-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent extends ParentModule implements OnInit, OnDestroy  {

  tab = 'Personal Info';
  permissioSsn = { showSsn: false, updateSsn: false, verifyDriverLicense: false, scanDriverLicense: false };
  showBackgroundCheck = false;
  isExpanded = false;
  expandedData: OnDemandDriverModel = new OnDemandDriverModel();
  private companies: ICompany[] = [];
  profilePhotoSafe = '';
  subscriptions: Subscription[] = [];
  @Input('ProviderId') ProviderId?: number;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Input() selected: number;
  @Input() name: string;
  @ViewChild('imagePOPProfile') imagePOPProfile: T2CardComponent;
  @ViewChild('personalInfo') personalInfo: PersonalInfoComponent;

  constructor(
    private service: OnDemandDriversService,
    private companiesService: CompaniesService,
    protected Inject: Injector,
  ) {
    super('ondemand-drivers', Inject);
    this.loadCompanies();
  }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit() {
    this.Observable();
    this.subscriptions.push(
      this.service.formExpanded$.subscribe({
        next: (expanded: boolean) => {
          this.isExpanded = expanded;
          if (expanded && this.selected) {
            this.loadExpandedData();
          }
        }
      })
    );
  }

  private loadCompanies(): void {
    const subscription = this.companiesService.getOnDemandCompanies().subscribe({
      next: (data: ICompany[]) => {
        this.companies = data;
      }
    });
    this.subscriptions.push(subscription);
  }

  private loadExpandedData(): void {
    this.service.getDriverByID(this.selected).pipe(take(1)).subscribe({
      next: (data: OnDemandDriverModel) => {
        this.expandedData = data;
        this.profilePhotoSafe = data.profilephoto || '';
      }
    });
  }

  get expandedHeaderTitle(): string {
    if (!this.isExpanded) {
      return 'Edit On-Demand Driver: ' + (this.name || '');
    }
    const first = this.expandedData && this.expandedData.firstname ? this.expandedData.firstname : '';
    const middle = this.expandedData && this.expandedData.middleinitial ? this.expandedData.middleinitial.trim() : '';
    const last = this.expandedData && this.expandedData.lastname ? this.expandedData.lastname : '';
    const full = [first, middle, last].filter((part) => !!part).join(' ');
    return full ? full : 'Edit On-Demand Driver: ' + (this.name || '');
  }

  get expandedCompanyCode(): string {
    if (!this.expandedData || !this.expandedData.companyid || !this.companies) {
      return '-';
    }
    const match = this.companies.find(
      (company: ICompany) => company.companyid === this.expandedData.companyid
    );
    return match && match.speedcode ? match.speedcode : '-';
  }

  get expandedStartDate(): string {
    return this.expandedData && this.expandedData.startdate
      ? this.expandedData.startdate
      : '-';
  }

  get expandedProfilePhotoUrl(): string {
    return this.profilePhotoSafe;
  }

  get hasExpandedProfilePhoto(): boolean {
    return !!(this.expandedData && this.expandedData.profilephoto);
  }

  openExpandedProfilePhoto(event: MouseEvent): void {
    if (this.hasExpandedProfilePhoto && this.imagePOPProfile) {
      this.imagePOPProfile.open(event);
    }
  }

  onHeaderActiveChange(isActive: boolean): void {
    if (this.personalInfo) {
      this.personalInfo.setActiveFromHeader(isActive);
      return;
    }
    this.expandedData.isactive = isActive;
  }

  onActiveChanged(isActive: boolean): void {
    this.expandedData.isactive = isActive;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }

  Observable() {
    this.subscriptions.push(
      this.actionsList$.subscribe((resp) => {
        if (resp && resp.length) {
          this.permissioSsn = {
            showSsn: resp.includes('ShowSsn'),
            updateSsn: resp.includes('UpdateSsn'),
            verifyDriverLicense: resp.includes('VerifyDriverLicense'),
            scanDriverLicense: resp.includes('ScanDriverLicense')
          };
          this.showBackgroundCheck = resp.includes('Checkr Report') && resp.includes('Checkr Dates');
        }
      })
    );
  }

  /**
   * @name cancelEdit
   * @description
   */
  cancelEdit($event?: any) {
    this.service.setFormExpanded(false);
    this.cancel.emit($event || true);
  }

  backToDrivers(): void {
    this.cancelEdit({ type: 'back' });
  }

  get cardHeaderClass(): { [key: string]: boolean } {
    return { 't2-card-main-header-expanded': this.isExpanded };
  }

  get isEmbeddedInProvider(): boolean {
    return typeof this.ProviderId === 'number' && !isNaN(this.ProviderId);
  }

  get showExpandedBackButton(): boolean {
    return this.isExpanded && !this.isEmbeddedInProvider;
  }

  /**
   * @name onNotify
   * @description
   * @param resp
   */
  onNotify(resp: any): void {
    this.notify.emit(resp);
  }

  onClickTab(option) {
    this.tab = option;
    if (this.tab === 'Personal Info') {
      this.service.isDisabledBtnSchedule(true);
    }
  }

  get loadBackgroundCheck(): boolean {
    return this.tab === 'Background Check' && this.showBackgroundCheck;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/edit/edit.component.ts